import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  LinearProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Backdrop,
  Snackbar,
  Typography,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  MenuItem,
  CardActions,
  Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SendIcon from '@material-ui/icons/Send';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import { Visibility } from '@material-ui/icons';
import { surveyActions, surveyThunks } from '../../store/slices/surveySlice'
import { connect, useDispatch, useSelector } from 'react-redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { setAlert } from 'src/store/actions';
import JSConfetti from 'js-confetti'

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    minHeight: 430
  },
  backdrop1: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  cardsMax: {
    maxHeight: 550,
    minHeight: 550
  },
  canvas: {
    width: '100%',
    height: '100%'
  }
}));
function SurveyScreen({ className, ReceiptNo, readonly, tasks }) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [Data, setData] = useState({});
  const SessionUser = getUser();
  const [ResponseDsc, setResponseDsc] = useState('');
  const [SurveyData, setSurveyData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [Lock, setLock] = React.useState(false);
  const [Loading, setLoading] = useState(true);
  const [AlertWarning, setAlertWarning] = React.useState(false);
  const [AlertType, setAlertType] = React.useState();
  const [VisibilityQuestionData, setVisibilityQuestionData] = useState([42]);
  const [SendParam, setSendParam] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const dispatch = useDispatch();
  const npsSurveyStatusList = useSelector((state) => state.survey.npsSurveyStatusList)
  const selectedNpsSurveyStatus = useSelector((state) => state.survey.selectedNpsSurveyStatus)

  const canvas = document.getElementById('your_custom_canvas_id')
  const jsConfetti = new JSConfetti({ canvas })

  useEffect(() => {
    const storeData = tasks.tasks.filter(
      d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
    );
    if (storeData.length !== 0) {
      setData(storeData[0]);
    } else {
      setData({});
    }
  }, [ReceiptNo, tasks.tasks, readonly]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/GetSurveyCustomer/${SessionUser.ServiceShopId}/${ReceiptNo}`)
      .then(response => {
        const ResponseData = response.data.Plan;
        if (ResponseData.length > -1) {
          setSurveyData(ResponseData);
          if (ResponseData[0]?.Question[0]?.QuestionAnswer[0]?.Selected > 0) {
            setLock(true);
          }
        }
        setLoading(false);
      })
      .catch(error => {
        setSurveyData([]);
        setLoading(false);
      });
  }, [SessionUser.ServiceShopId]);

  useEffect(() => {
    dispatch(surveyThunks.GetNpsSurveyStatusList()).then((response) => {
      dispatch(surveyThunks.GetWorkOrdersNpsSurveyStatus(({
        workOrderId: ReceiptNo
      }))).then((res) => {
        dispatch(surveyActions.setSelectedNpsSurveyStatus(res.payload))
      })
    })
  }, [])

  const SetNpsSurveyStatus = () => {
    let data = {
      WorkOrderId: ReceiptNo,
      NpsSurveyStatusId: selectedNpsSurveyStatus.Id
    }

    dispatch(surveyThunks.SaveNpsSurveyStatusWorkOrder(data)).then(response => {
      if (response?.payload?.ErrorCode === '400') {
        jsConfetti.addConfetti({
          // emojis: ['🌈', '⚡️', '💥', '✨', '💫', '🌸']
          emojis: ['😻', '🐉', '🐔', '🍸', '🧿', '💐']
        })
        setResponseDsc(t('lblNpsSurveySaveSuccess'));
        setAlertType('success');
        setOpenSnackbar(true)
      }
      else {
        setResponseDsc(response?.payload?.ErrorDescription);
        setAlertType('error');
        setOpenSnackbar(true)
      }
    })
  }

  const handleClose = () => {
    setOpen(false);
  };

  const AlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertWarning(false);
  };

  const handleCheckBoxChange = event => {
    const Data = [...SurveyData];
    var indexParam = -1;
    if (event.target.checked) {
      const Value = { Selected: parseInt(event.target.value) };
      const index = Data[0].Question.findIndex(
        x => parseInt(x.QuestionId) === parseInt(event.target.name)
      );
      indexParam = index;
      Data[0].Question[index].QuestionAnswer.push(Value);
    } else {
      const indexData = Data[0].Question.findIndex(
        x => parseInt(x.QuestionId) === parseInt(event.target.name)
      );
      const indexSelected = Data[0].Question.filter(
        x => parseInt(x.QuestionId) === parseInt(event.target.name)
      )[0].QuestionAnswer.findIndex(
        y => parseInt(y.Selected) === parseInt(event.target.value)
      );
      indexParam = indexData;
      Data[0].Question[indexData].QuestionAnswer.splice(indexSelected, 1);
    }

    var VisibleValue = Data[0].Question[indexParam].Answer.filter(x => parseInt(x.AnswerId) === parseInt(event.target.value))[0].VisibleQuestion;
    const ChooseQuestion = [];
    Data.forEach(item => {
      item.Question.forEach(itemQuestion => {
        itemQuestion.QuestionAnswer.forEach(itemAnswer => {
          if (itemAnswer.Selected.toString() !== '0') {
            ChooseQuestion.push(parseInt(itemQuestion.QuestionId));
          }
        });
      });
    });
    ChooseQuestion.push(VisibleValue);
    setVisibilityQuestionData(ChooseQuestion);


    setSurveyData(Data);
  };

  const handleRadioChange = event => {
    const DataRadio = [...SurveyData];
    const SendParam1 = [...SendParam];
    const index = DataRadio[0].Question.findIndex(
      x => parseInt(x.QuestionId) === parseInt(event.target.name)
    );
    DataRadio[0].Question[index].QuestionAnswer[0].Selected = event.target.value;

    var VisibleValue = DataRadio[0].Question[index].Answer.filter(x => parseInt(x.AnswerId) === parseInt(event.target.value))[0].VisibleQuestion;
    const ChooseQuestion = [];
    DataRadio.forEach(item => {
      item.Question.forEach(itemQuestion => {
        itemQuestion.QuestionAnswer.forEach(itemAnswer => {
          if (itemAnswer.Selected.toString() !== '0') {
            ChooseQuestion.push(parseInt(itemQuestion.QuestionId));
          }
        });
      });
    });

    var ParamData = { Question: DataRadio[0].Question[index].QuestionId, Answer: event.target.value, ShowType: 1 };
    var filteredIndex = SendParam1.findIndex(x => x.Question === DataRadio[0].Question[index].QuestionId);
    if (filteredIndex > -1) {
      SendParam1.splice(filteredIndex, 1);
    }
    SendParam1.push(ParamData);
    setSendParam(SendParam1);
    ChooseQuestion.push(VisibleValue);
    setVisibilityQuestionData(ChooseQuestion);

    setSurveyData(DataRadio);
  };

  const handleComboChange = event => {
    const Data = [...SurveyData];
    const index = Data[0].Question.findIndex(
      x => parseInt(x.QuestionId) === parseInt(event.target.name)
    );
    Data[0].Question[index].QuestionAnswer[0].Selected = event.target.value;

    var VisibleValue = Data[0].Question[index].Answer.filter(x => parseInt(x.AnswerId) === parseInt(event.target.value))[0].VisibleQuestion;
    const ChooseQuestion = [];
    Data.forEach(item => {
      item.Question.forEach(itemQuestion => {
        itemQuestion.QuestionAnswer.forEach(itemAnswer => {
          if (itemAnswer.Selected.toString() !== '0') {
            ChooseQuestion.push(parseInt(itemQuestion.QuestionId));
          }
        });
      });
    });
    ChooseQuestion.push(VisibleValue);
    setVisibilityQuestionData(ChooseQuestion);



    setSurveyData(Data);
  };
  const handleTextBoxChange = event => {
    const Data = [...SurveyData];
    const SendParam1 = [...SendParam];
    const index = Data[0].Question.findIndex(
      x => parseInt(x.QuestionId) === parseInt(event.target.name)
    );
    Data[0].Question[index].QuestionAnswer[0].Selected = event.target.value;
    setSurveyData(Data);

    var ParamData = { Question: Data[0].Question[index].QuestionId, Answer: event.target.value, ShowType: 1 };
    var filteredIndex = SendParam1.findIndex(x => x.Question === Data[0].Question[index].QuestionId);
    if (filteredIndex > -1) {
      SendParam1.splice(filteredIndex, 1);
    }
    SendParam1.push(ParamData);
    setSendParam(SendParam1);


  };

  const getAnswer = (Question, ShowType, index) => {
    let ReturnOject;
    switch (ShowType) {
      case 1:
        ReturnOject = (
          <RadioGroup
            aria-label="Answer"
            size="small"
            disabled={Lock}
            name={Question.QuestionId}
            onChange={handleRadioChange}
            value={parseInt(Question.QuestionAnswer[0]?.Selected)}
          >
            {Question?.Answer?.map(AnswerItem => {
              return (
                <FormControlLabel
                  id={AnswerItem.AnswerId}
                  size="small"
                  value={AnswerItem.AnswerId}
                  control={<Radio size="small" />}
                  label={AnswerItem.AnswerDescription}
                />
              );
            })}
          </RadioGroup>
        );
        return ReturnOject;
      case 2:
        ReturnOject = (
          <div>
            {Question?.Answer?.map(AnswerItem => {
              return (
                <FormControlLabel
                  size="small"
                  id={AnswerItem.AnswerId}
                  value={AnswerItem.AnswerId}
                  control={
                    <Checkbox
                      size={'small'}
                      checked={
                        Question.QuestionAnswer?.filter(
                          x => x.Selected.toString() === AnswerItem.AnswerId.toString()
                        ).length > 0
                          ? true
                          : false
                      }
                      onChange={handleCheckBoxChange}
                      disabled={Lock}
                      name={Question.QuestionId}
                      value={AnswerItem.AnswerId}
                      color="primary"
                    />
                  }
                  label={AnswerItem.AnswerDescription}
                />
              );
            })}
          </div>
        );
        return ReturnOject;
      case 3:
        ReturnOject = (
          <TextField
            size="small"
            fullWidth
            select
            autoComplete="no"
            disabled={Lock}
            name={Question.QuestionId}
            value={Question.QuestionAnswer[0]?.Selected}
            onChange={handleComboChange}
            variant="outlined"
          >
            {Question?.Answer?.map(AnswerItem => {
              return (
                <MenuItem key={AnswerItem.AnswerId} value={AnswerItem.AnswerId}>
                  {AnswerItem.AnswerDescription}
                </MenuItem>
              );
            })}
          </TextField>
        );
        return ReturnOject;
      case 4:
        ReturnOject = (
          <TextField
            size="small"
            multiline
            rows={3}
            fullWidth
            disabled={Lock}
            name={Question.QuestionId}
            // id={Question.Answer[0]?.AnswerId}
            autoComplete="no"
            onChange={handleTextBoxChange}
            value={
              Question?.QuestionAnswer ?
                Question?.QuestionAnswer[0]?.Selected?.toString() === '0'
                  ? ''
                  : Question.QuestionAnswer[0]?.Selected
                : ''
            }
            variant="outlined"
          />
        );

        return ReturnOject;
    }
  };

  const setSurvey = () => {
    setLoading(true);
    let RequestSurveyData;
    const RequestData = [];
    let RequestAnswer;
    let Control = 0;
    RequestAnswer = '';
    SurveyData.forEach(item => {
      item.Question.forEach(itemQuestion => {
        itemQuestion.QuestionAnswer.forEach(itemAnswer => {
          if (itemAnswer.Selected.toString() !== '0') {
            RequestAnswer += `,${itemAnswer.Selected}`;
          }
        });
        RequestSurveyData = {
          Question: itemQuestion.QuestionId,
          Answer: RequestAnswer,
          ShowType: itemQuestion.ShowType
        };



        RequestData.push(RequestSurveyData);
      });

      if (RequestAnswer === '') {
        Control = 1;
      }

      if (Control === 1) {
        setResponseDsc(t('lblChooseError'));
        setAlertType('error');
        setAlertWarning(true);
        setLoading(false);
        setOpen(true);
        return;
      }

      const data = {
        ServiceShopId: SessionUser.ServiceShopId,
        EmployeeId: SessionUser.TechnicianId,
        WorkOrderId: ReceiptNo,
        PlanId: item.PlanId,
        Survey: SendParam
      };

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };


      axios
        .post('/SetSurvey', data, config)
        .then(response => {
          setResponseDsc(t('lblSuccess'));
          setAlertType('success');
          setAlertWarning(true);
          setLoading(false);
          setOpen(true);
          setLock(true);
        })
        .catch(error => {
          setLoading(false);
        });
    });
  };

  return (
    // <div style={{ position: 'relative', height: '100vh' }}>
    //   <canvas id="custom_canvas" style={{ zIndex: 1, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}></canvas>
    //   <Card style={{ zIndex: 2, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', overflow: 'hidden' }}>

    //     <Snackbar
    //       open={AlertWarning}
    //       autoHideDuration={6000}
    //       onClose={AlertClose}
    //     >
    //       <Alert onClose={AlertClose} message={ResponseDsc} variant={AlertType} />
    //       <Alert></Alert>
    //     </Snackbar>

    //     <CardHeader title={t('Anket_islemleri')} />
    //     <Divider />
    //     <CardContent className={classes.contentAnket}>
    //       <Grid container spacing={1}>
    //         <Grid item xs={12} sm={6} lg={6}>
    //         </Grid>
    //         <Grid item xs={12} sm={4} lg={4}>
    //           <Autocomplete
    //             size="small"
    //             fullWidth
    //             autoSelect
    //             disableClearable
    //             options={npsSurveyStatusList || []}
    //             getOptionLabel={option => (option ? option.StatusName : '')}
    //             value={selectedNpsSurveyStatus || null}
    //             renderInput={params => (
    //               <TextField
    //                 {...params}
    //                 label={t('lblNpsSurveyStatus')}
    //                 variant="outlined"
    //               />
    //             )}
    //             onChange={(event, value) => {
    //               dispatch(surveyActions.setSelectedNpsSurveyStatus(value))
    //             }}
    //           />
    //         </Grid>
    //         <Grid item xs={12} sm={2} lg={2}>
    //           <Button
    //             variant="contained"
    //             color="primary"
    //             size="small"
    //             // disabled={Lock}
    //             onClick={SetNpsSurveyStatus}
    //             endIcon={<SendIcon>Save Status</SendIcon>}
    //           >
    //             {t('lblSaveStatus')}
    //           </Button>
    //         </Grid>
    //       </Grid>
    //       {Loading ? <LinearProgress /> : ''}
    //       {SurveyData?.map((itemPlan, index) => (
    //         <div key={index}>
    //           <Typography variant="h6" gutterBottom>
    //             {itemPlan.PlanDescription}
    //           </Typography>
    //           <Divider />
    //           {itemPlan?.Question?.map((itemQuestion, index) => (
    //             VisibilityQuestionData.map((itemVisible, index) => (
    //               parseInt(itemVisible) === parseInt(itemQuestion?.QuestionId) ?
    //                 <div key={index}>
    //                   <Typography variant="h6">
    //                     {`${index + 1}) ${itemQuestion?.Question}`}
    //                   </Typography>
    //                   {getAnswer(itemQuestion, itemQuestion.ShowType, index)}
    //                 </div>
    //                 : ""
    //             ))

    //           ))}
    //         </div>
    //       ))}
    //       <Snackbar
    //         open={openSnackbar}
    //         autoHideDuration={6000}
    //         onClose={() => setOpenSnackbar(false)}
    //         anchorOrigin={{
    //           vertical: 'top',
    //           horizontal: 'center'
    //         }}
    //       >
    //         <Alert onClose={() => setOpenSnackbar(false)} severity={AlertType}>
    //           {ResponseDsc}
    //         </Alert>
    //       </Snackbar>
    //     </CardContent>
    //     <Dialog
    //       open={openSnackbar}
    //       onClose={() => setOpenSnackbar(false)}
    //       aria-labelledby="alert-dialog-slide-title"
    //       aria-describedby="alert-dialog-slide-description"
    //     >
    //       <DialogTitle id="alert-dialog-slide-title" color="primary">
    //         {t('Bilgilendirme')}
    //       </DialogTitle>
    //       <DialogContent>
    //         <DialogContentText id="alert-dialog-slide-description">
    //           {ResponseDsc}
    //         </DialogContentText>
    //       </DialogContent>
    //       <DialogActions>
    //         <Button onClick={() => setOpenSnackbar(false)} color="primary">
    //           {t('Tamam')}
    //         </Button>
    //       </DialogActions>
    //     </Dialog>
    //     <CardActions>
    //       <Button
    //         variant="contained"
    //         color="primary"
    //         size="small"
    //         disabled={Lock}
    //         onClick={setSurvey}
    //         endIcon={<SendIcon>Send</SendIcon>}
    //       >
    //         {t('lblSave')}
    //       </Button>
    //     </CardActions>

    //   </Card>
    // </div>
    <div style={{ position: 'relative', height: '100vh' }}> {/* Sayfanın tamamını kapsayan bir div */}

      <canvas id="custom_canvas" className={classes.canvas} style={{ zIndex: 1, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}></canvas>

      <Card style={{ zIndex: 2, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Snackbar
          open={AlertWarning}
          autoHideDuration={6000}
          onClose={AlertClose}
        >
          <Alert onClose={AlertClose} message={ResponseDsc} variant={AlertType} />
        </Snackbar>

        <CardHeader title={t('Anket_islemleri')} />
        <Divider />

        <CardContent className={classes.contentAnket} style={{ flexGrow: 1, overflowY: 'auto' }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} lg={6}>
            </Grid>
            <Grid item xs={12} sm={4} lg={4}>
              <Autocomplete
                size="small"
                fullWidth
                autoSelect
                disableClearable
                options={npsSurveyStatusList || []}
                getOptionLabel={option => (option ? option.StatusName : '')}
                value={selectedNpsSurveyStatus || null}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('lblNpsSurveyStatus')}
                    variant="outlined"
                  />
                )}
                onChange={(event, value) => {
                  dispatch(surveyActions.setSelectedNpsSurveyStatus(value))
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={SetNpsSurveyStatus}
                endIcon={<SendIcon>Save Status</SendIcon>}
              >
                {t('lblSaveStatus')}
              </Button>
            </Grid>
          </Grid>
          {Loading ? <LinearProgress /> : ''}
          {SurveyData?.map((itemPlan, index) => (
            <div key={index}>
              <Typography variant="h6" gutterBottom>
                {itemPlan.PlanDescription}
              </Typography>
              <Divider />
              {itemPlan?.Question?.map((itemQuestion, index) => (
                VisibilityQuestionData.map((itemVisible, index) => (
                  parseInt(itemVisible) === parseInt(itemQuestion?.QuestionId) ?
                    <div key={index}>
                      <Typography variant="h6">
                        {`${index + 1}) ${itemQuestion?.Question}`}
                      </Typography>
                      {getAnswer(itemQuestion, itemQuestion.ShowType, index)}
                    </div>
                    : ""
                ))
              ))}
            </div>
          ))}
        </CardContent>
        <Dialog
          open={openSnackbar}
          onClose={() => setOpenSnackbar(false)}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">
            {t('Bilgilendirme')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {ResponseDsc}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenSnackbar(false)} color="primary">
              {t('Tamam')}
            </Button>
          </DialogActions>
        </Dialog>
        <CardActions style={{ justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            disabled={Lock}
            onClick={setSurvey}
            endIcon={<SendIcon>Send</SendIcon>}
          >
            {t('lblSave')}
          </Button>
        </CardActions>
      </Card>
    </div>



  );
}
SurveyScreen.propTypes = {
  className: PropTypes.string
};
export default connect(state => ({
  tasks: state.tasks1
}))(SurveyScreen);
